import {getCurrentInstance} from 'vue';
import type {ComponentInternalInstance} from '@vue/runtime-core';

/**
 * Shortcut for accessing context and to replace `this` when migrating to composition api
 * ### ⚠️ Only use inside `setup` function or in a composable
 *
 * @example
 *  ```ts
 *  setup() {
 *     const {root, parent} = useVueInternals();
 *  }
 *  ```
 */
export function useVueInternals(): ComponentInternalInstance {
    const app: any = getCurrentInstance();
    if (app) {
        return app as ComponentInternalInstance;
    }
    throw new Error('Only use "useVueInternals" inside setup function or in a composable');
}
